export default {
  props: {
    /**
      * Placeholder for elements awaiting content entry from the user
      */
    placeholder: {type: String, default: 'Please select...'},
  }
};
